import React from 'react';
import PropTypes from 'prop-types';
import CountryPhoneCodeInput from '../Global/Forms/CountryPhoneCodeInput';
import TelInput from '../Global/Forms/TelInput';
import PasswordRequirements from '../Global/Forms/PasswordRequirements';
import PasswordInput from '../Global/Forms/PasswordInput';

const AccountSecurity = ({ title, values, errors, touched, onChange, onCountryPhoneCodeChange }) => (
  <div className="user-information">
    {title}
    <fieldset className="m-b-5">
      <span className="faux-label label-required">Phone number</span>
      <p className="like-small color-grey">We require a phone number to allow you to recover your account if you lose access to your email</p>

      <div className="row">
        <div className="col-lg-4">
          <CountryPhoneCodeInput
            name="areaCode1"
            value={values.areaCode1}
            onChange={onCountryPhoneCodeChange}
            error={errors.areaCode1}
            touched={touched.areaCode1}
            required
          />
        </div>

        <div className="col-lg-8">
          <TelInput
            name="telNo1"
            maxLength={50}
            value={values.telNo1}
            onChange={onChange}
            error={errors.telNo1}
            touched={touched.telNo1}
            required
          />
        </div>
      </div>

      <PasswordRequirements value={values.password} />

      <div className="row">
        <div className="col-lg-6">
          <PasswordInput
            name="password"
            label="Password"
            maxLength={100}
            value={values.password}
            onChange={onChange}
            error={errors.password}
            touched={touched.password}
            required
          />
        </div>

        <div className="col-lg-6">
          <PasswordInput
            name="confirmPassword"
            label="Confirm password"
            maxLength={100}
            value={values.confirmPassword}
            onChange={onChange}
            error={errors.confirmPassword}
            touched={touched.confirmPassword}
            required
          />
        </div>
      </div>
    </fieldset>
  </div>
);

AccountSecurity.propTypes = {
  title: PropTypes.object,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onCountryPhoneCodeChange: PropTypes.func.isRequired,
};

export default AccountSecurity;



// WEBPACK FOOTER //
// ./library/app/components/Signup/AccountSecurity.js